import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';

export default {
  install: (Vue) => {
    Vue.use(VueAwesomeSwiper);
  }
}